import { ApolloClient } from '@apollo/client';

import type { SuggestedAnswerFragment } from './suggested-answers.graphql.generated';
import {
  ACTIVITIES_CONTENT_STATUS_DRAFT,
  LANGUAGE_CODE_EN_AU,
} from 'global/constants';

export function updateSuggestedAnswerInCache({
  client,
  id,
  typename,
  properties,
}: {
  client: ApolloClient<any>;
  id: string;
  typename: string;
  properties: SuggestedAnswerFragment;
}) {
  client.cache.modify({
    id: client.cache.identify({
      id,
      __typename: typename,
      language: LANGUAGE_CODE_EN_AU,
      version: ACTIVITIES_CONTENT_STATUS_DRAFT,
    }),
    fields: {
      suggestedAnswerProperties(existing) {
        return {
          ...existing,
          ...properties,
        };
      },
    },
  });
}
